import {ICellRendererParams} from "@ag-grid-community/core";
import {Popover} from "@blueprintjs/core";
import styled from "@emotion/styled";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ManifestStop, Stop} from "../../../generated/graphql";
import {EmptyValueStrings} from "../../../constants/constants";

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
`;

const Icon = styled(FontAwesomeIcon)`
  cursor: pointer;
`;

const CellContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledPopover = styled(Popover)``;

const DetailHeader = styled.span`
  font-size: 12px;
  font-weight: 500;
`;

const DetailContent = styled.span`
  font-size: 12px;
  font-weight: 300;
`;

const contactContent = (manifestStop: ManifestStop | Stop) => {
  const see = manifestStop.see ? (
    <span>
      <br />
      {manifestStop.see}
    </span>
  ) : undefined;
  const phone = manifestStop.phone ? (
    <span>
      <br />
      {manifestStop.phone}
    </span>
  ) : undefined;
  const notSet = !see && !phone ? EmptyValueStrings.notProvided : undefined;
  return (
    <div>
      <DetailHeader>CONTACT: </DetailHeader>
      <DetailContent>
        {notSet}
        {see}
        {phone}
      </DetailContent>
    </div>
  );
};

const notesContent = (notes: string | undefined | null, label: string) => {
  notes = notes ?? EmptyValueStrings.notAvailable;
  return (
    <div>
      <DetailHeader>{label}:</DetailHeader>
      <DetailContent> {notes}</DetailContent>
    </div>
  );
};

const renderEmptyContent = () => {
  return (
    <CellContainer>
      <Icon icon={solid("memo-circle-info")} size={"lg"} color="#9CA3AF" />
    </CellContainer>
  );
};

const renderContent = (
  contactDetails: React.ReactNode,
  orderNotes: React.ReactNode,
  stopNotes: React.ReactNode,
  customerNotes: React.ReactNode
) => {
  return (
    <CellContainer>
      <StyledPopover
        content={
          <ContentContainer>
            {contactDetails}
            {orderNotes}
            {stopNotes}
            {customerNotes}
          </ContentContainer>
        }
      >
        <Icon icon={solid("memo-circle-info")} size={"lg"} color="#9CA3AF" />
      </StyledPopover>
    </CellContainer>
  );
};

export const DetailsCellRenderer = (props: ICellRendererParams<ManifestStop, string | undefined>) => {
  if (!props.data) return renderEmptyContent();

  const contactDetails = contactContent(props.data);
  const orderNotes = notesContent(props.data?.order?.notes, "ORDER NOTES");
  const stopNotes = notesContent(props.data?.note, "STOP NOTES");
  const customerNotes = notesContent(props.data?.order?.customer?.notes, "CUSTOMER NOTES");

  return renderContent(contactDetails, orderNotes, stopNotes, customerNotes);
};
